import { Link } from "react-router-dom";
import { Reveal, Overline } from "@/components/Reveal";

// Compact editorial teaser → About. Built so a real portrait can slot into a
// left image column later (keep the flex row); no placeholder shown for now.
export default function MeetShi() {
  return (
    <section data-testid="meet-shi-section" className="py-16 md:py-20">
      <div className="mx-auto max-w-5xl px-5 md:px-10">
        <Reveal>
          <div className="rounded-3xl border border-corduroy bg-cocoa p-8 md:p-12">
            <Overline>Meet SHi</Overline>
            <h2 className="mt-4 max-w-3xl font-display text-3xl font-black leading-[0.95] tracking-tight md:text-5xl">
              Ashyla, or SHi.{" "}
              <span className="italic text-gold">Depends where you know me from.</span>
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-latte md:text-lg">
              Singer, rapper, commentator &mdash; and somebody who has always had
              a lot to say.
            </p>
            <Link
              to="/about"
              data-testid="meet-shi-cta"
              className="mt-8 inline-block rounded-full border border-gold/60 px-7 py-3.5 text-sm font-bold uppercase tracking-[0.18em] text-gold transition-colors hover:bg-gold hover:text-ink"
            >
              Meet SHi &rarr;
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
